var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppstoreQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 0H48.8206V4.93807H53.7587V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 0H67.9976V4.93807H72.9356V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 0H72.7918V4.93807H77.7299V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 0H77.5861V4.93807H82.5241V0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 4.79425H44.0263V9.73232H48.9644V4.79425Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 4.79425H48.8206V9.73232H53.7587V4.79425Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 4.79425H53.6148V9.73232H58.5529V4.79425Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 4.79425H58.4091V9.73232H63.3472V4.79425Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 9.58849H39.2321V14.5266H44.1702V9.58849Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 9.58849H63.2033V14.5266H68.1414V9.58849Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 9.58849H72.7918V14.5266H77.7299V9.58849Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 14.3827H39.2321V19.3208H44.1702V14.3827Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 14.3827H53.6148V19.3208H58.5529V14.3827Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 14.3827H58.4091V19.3208H63.3472V14.3827Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 14.3827H63.2033V19.3208H68.1414V14.3827Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 14.3827H72.7918V19.3208H77.7299V14.3827Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 19.177H39.2321V24.1151H44.1702V19.177Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 19.177H44.0263V24.1151H48.9644V19.177Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 19.177H48.8206V24.1151H53.7587V19.177Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 19.177H58.4091V24.1151H63.3472V19.177Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 19.177H67.9976V24.1151H72.9356V19.177Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 19.177H72.7918V24.1151H77.7299V19.177Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 23.9712H39.2321V28.9093H44.1702V23.9712Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 23.9712H48.8206V28.9093H53.7587V23.9712Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 23.9712H53.6148V28.9093H58.5529V23.9712Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 23.9712H58.4091V28.9093H63.3472V23.9712Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 23.9712H77.5861V28.9093H82.5241V23.9712Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 28.7655H39.2321V33.7036H44.1702V28.7655Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 28.7655H48.8206V33.7036H53.7587V28.7655Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 28.7655H58.4091V33.7036H63.3472V28.7655Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 28.7655H67.9976V33.7036H72.9356V28.7655Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 28.7655H77.5861V33.7036H82.5241V28.7655Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 33.5597H39.2321V38.4978H44.1702V33.5597Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 33.5597H58.4091V38.4978H63.3472V33.5597Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 33.5597H63.2033V38.4978H68.1414V33.5597Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 33.5597H72.7918V38.4978H77.7299V33.5597Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 38.354H0.878113V43.2921H5.81619V38.354Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 38.354H10.4666V43.2921H15.4047V38.354Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1989 38.354H15.2609V43.2921H20.1989V38.354Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 38.354H20.0551V43.2921H24.9932V38.354Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7874 38.354H24.8493V43.2921H29.7874V38.354Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5817 38.354H29.6436V43.2921H34.5817V38.354Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 38.354H44.0263V43.2921H48.9644V38.354Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 38.354H53.6148V43.2921H58.5529V38.354Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 38.354H58.4091V43.2921H63.3472V38.354Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 38.354H67.9976V43.2921H72.9356V38.354Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 38.354H72.7918V43.2921H77.7299V38.354Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 38.354H77.5861V43.2921H82.5241V38.354Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 38.354H87.1746V43.2921H92.1126V38.354Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 38.354H91.9688V43.2921H96.9069V38.354Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 38.354H96.7631V43.2921H101.701V38.354Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 38.354H101.557V43.2921H106.495V38.354Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 38.354H106.352V43.2921H111.29V38.354Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 43.1482H10.4666V48.0863H15.4047V43.1482Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7874 43.1482H24.8493V48.0863H29.7874V43.1482Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 43.1482H39.2321V48.0863H44.1702V43.1482Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 43.1482H48.8206V48.0863H53.7587V43.1482Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 43.1482H58.4091V48.0863H63.3472V43.1482Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 43.1482H67.9976V48.0863H72.9356V43.1482Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 43.1482H72.7918V48.0863H77.7299V43.1482Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 43.1482H77.5861V48.0863H82.5241V43.1482Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3184 43.1482H82.3803V48.0863H87.3184V43.1482Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 43.1482H96.7631V48.0863H101.701V43.1482Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 43.1482H101.557V48.0863H106.495V43.1482Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 43.1482H111.146V48.0863H116.084V43.1482Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 43.1482H115.94V48.0863H120.878V43.1482Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6104 47.9425H5.67236V52.8805H10.6104V47.9425Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1989 47.9425H15.2609V52.8805H20.1989V47.9425Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5817 47.9425H29.6436V52.8805H34.5817V47.9425Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3759 47.9425H34.4378V52.8805H39.3759V47.9425Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 47.9425H44.0263V52.8805H48.9644V47.9425Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 47.9425H58.4091V52.8805H63.3472V47.9425Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 47.9425H87.1746V52.8805H92.1126V47.9425Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 47.9425H101.557V52.8805H106.495V47.9425Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 47.9425H111.146V52.8805H116.084V47.9425Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 52.7367H0.878113V57.6748H5.81619V52.7367Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6104 52.7367H5.67236V57.6748H10.6104V52.7367Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 52.7367H20.0551V57.6748H24.9932V52.7367Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3759 52.7367H34.4378V57.6748H39.3759V52.7367Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 52.7367H48.8206V57.6748H53.7587V52.7367Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 52.7367H58.4091V57.6748H63.3472V52.7367Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 52.7367H63.2033V57.6748H68.1414V52.7367Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 52.7367H67.9976V57.6748H72.9356V52.7367Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 52.7367H87.1746V57.6748H92.1126V52.7367Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 52.7367H101.557V57.6748H106.495V52.7367Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 52.7367H106.352V57.6748H111.29V52.7367Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 52.7367H111.146V57.6748H116.084V52.7367Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 52.7367H115.94V57.6748H120.878V52.7367Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 57.531H0.878113V62.469H5.81619V57.531Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 57.531H10.4666V62.469H15.4047V57.531Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5817 57.531H29.6436V62.469H34.5817V57.531Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3759 57.531H34.4378V62.469H39.3759V57.531Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 57.531H39.2321V62.469H44.1702V57.531Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 57.531H53.6148V62.469H58.5529V57.531Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 57.531H58.4091V62.469H63.3472V57.531Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 57.531H77.5861V62.469H82.5241V57.531Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 57.531H87.1746V62.469H92.1126V57.531Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 57.531H91.9688V62.469H96.9069V57.531Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 57.531H106.352V62.469H111.29V57.531Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 57.531H115.94V62.469H120.878V57.531Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 62.3252H0.878113V67.2633H5.81619V62.3252Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 62.3252H10.4666V67.2633H15.4047V62.3252Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1989 62.3252H15.2609V67.2633H20.1989V62.3252Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 62.3252H20.0551V67.2633H24.9932V62.3252Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7874 62.3252H24.8493V67.2633H29.7874V62.3252Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 62.3252H39.2321V67.2633H44.1702V62.3252Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 62.3252H44.0263V67.2633H48.9644V62.3252Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 62.3252H48.8206V67.2633H53.7587V62.3252Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 62.3252H67.9976V67.2633H72.9356V62.3252Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 62.3252H91.9688V67.2633H96.9069V62.3252Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 62.3252H96.7631V67.2633H101.701V62.3252Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 62.3252H101.557V67.2633H106.495V62.3252Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 62.3252H106.352V67.2633H111.29V62.3252Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 67.1195H0.878113V72.0575H5.81619V67.1195Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 67.1195H10.4666V72.0575H15.4047V67.1195Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1989 67.1195H15.2609V72.0575H20.1989V67.1195Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 67.1195H20.0551V72.0575H24.9932V67.1195Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5817 67.1195H29.6436V72.0575H34.5817V67.1195Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3759 67.1195H34.4378V72.0575H39.3759V67.1195Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 67.1195H44.0263V72.0575H48.9644V67.1195Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 67.1195H48.8206V72.0575H53.7587V67.1195Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 67.1195H53.6148V72.0575H58.5529V67.1195Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 67.1195H58.4091V72.0575H63.3472V67.1195Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 67.1195H63.2033V72.0575H68.1414V67.1195Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 67.1195H67.9976V72.0575H72.9356V67.1195Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 67.1195H87.1746V72.0575H92.1126V67.1195Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 67.1195H96.7631V72.0575H101.701V67.1195Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 67.1195H106.352V72.0575H111.29V67.1195Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 71.9137H0.878113V76.8518H5.81619V71.9137Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 71.9137H10.4666V76.8518H15.4047V71.9137Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 71.9137H20.0551V76.8518H24.9932V71.9137Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 71.9137H39.2321V76.8518H44.1702V71.9137Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 71.9137H48.8206V76.8518H53.7587V71.9137Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 71.9137H53.6148V76.8518H58.5529V71.9137Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 71.9137H63.2033V76.8518H68.1414V71.9137Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 71.9137H67.9976V76.8518H72.9356V71.9137Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 71.9137H72.7918V76.8518H77.7299V71.9137Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 71.9137H87.1746V76.8518H92.1126V71.9137Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 71.9137H106.352V76.8518H111.29V71.9137Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 71.9137H115.94V76.8518H120.878V71.9137Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81619 76.708H0.878113V81.646H5.81619V76.708Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 76.708H10.4666V81.646H15.4047V76.708Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1989 76.708H15.2609V81.646H20.1989V76.708Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5817 76.708H29.6436V81.646H34.5817V76.708Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 76.708H39.2321V81.646H44.1702V76.708Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 76.708H44.0263V81.646H48.9644V76.708Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 76.708H53.6148V81.646H58.5529V76.708Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 76.708H58.4091V81.646H63.3472V76.708Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 76.708H67.9976V81.646H72.9356V76.708Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 76.708H72.7918V81.646H77.7299V76.708Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 76.708H77.5861V81.646H82.5241V76.708Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3184 76.708H82.3803V81.646H87.3184V76.708Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 76.708H87.1746V81.646H92.1126V76.708Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 76.708H91.9688V81.646H96.9069V76.708Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 76.708H96.7631V81.646H101.701V76.708Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 76.708H115.94V81.646H120.878V76.708Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 81.5022H39.2321V86.4403H44.1702V81.5022Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 81.5022H58.4091V86.4403H63.3472V81.5022Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 81.5022H67.9976V86.4403H72.9356V81.5022Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 81.5022H77.5861V86.4403H82.5241V81.5022Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 81.5022H96.7631V86.4403H101.701V81.5022Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 81.5022H101.557V86.4403H106.495V81.5022Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 81.5022H111.146V86.4403H116.084V81.5022Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 81.5022H115.94V86.4403H120.878V81.5022Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 86.2964H44.0263V91.2345H48.9644V86.2964Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 86.2964H58.4091V91.2345H63.3472V86.2964Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 86.2964H72.7918V91.2345H77.7299V86.2964Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 86.2964H77.5861V91.2345H82.5241V86.2964Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 86.2964H87.1746V91.2345H92.1126V86.2964Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 86.2964H96.7631V91.2345H101.701V86.2964Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 86.2964H101.557V91.2345H106.495V86.2964Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 86.2964H111.146V91.2345H116.084V86.2964Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 91.0907H39.2321V96.0288H44.1702V91.0907Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 91.0907H53.6148V96.0288H58.5529V91.0907Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 91.0907H63.2033V96.0288H68.1414V91.0907Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 91.0907H77.5861V96.0288H82.5241V91.0907Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 91.0907H96.7631V96.0288H101.701V91.0907Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 91.0907H101.557V96.0288H106.495V91.0907Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 91.0907H106.352V96.0288H111.29V91.0907Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 91.0907H111.146V96.0288H116.084V91.0907Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 91.0907H115.94V96.0288H120.878V91.0907Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 95.8849H39.2321V100.823H44.1702V95.8849Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 95.8849H63.2033V100.823H68.1414V95.8849Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 95.8849H77.5861V100.823H82.5241V95.8849Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3184 95.8849H82.3803V100.823H87.3184V95.8849Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 95.8849H87.1746V100.823H92.1126V95.8849Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 95.8849H91.9688V100.823H96.9069V95.8849Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 95.8849H96.7631V100.823H101.701V95.8849Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 95.8849H106.352V100.823H111.29V95.8849Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 100.679H39.2321V105.617H44.1702V100.679Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 100.679H44.0263V105.617H48.9644V100.679Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 100.679H48.8206V105.617H53.7587V100.679Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 100.679H58.4091V105.617H63.3472V100.679Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 100.679H63.2033V105.617H68.1414V100.679Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 100.679H67.9976V105.617H72.9356V100.679Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 100.679H77.5861V105.617H82.5241V100.679Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3184 100.679H82.3803V105.617H87.3184V100.679Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9069 100.679H91.9688V105.617H96.9069V100.679Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 100.679H96.7631V105.617H101.701V100.679Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 100.679H101.557V105.617H106.495V100.679Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 100.679H111.146V105.617H116.084V100.679Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 100.679H115.94V105.617H120.878V100.679Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 105.473H39.2321V110.412H44.1702V105.473Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9644 105.473H44.0263V110.412H48.9644V105.473Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 105.473H48.8206V110.412H53.7587V105.473Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5529 105.473H53.6148V110.412H58.5529V105.473Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 105.473H67.9976V110.412H72.9356V105.473Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 105.473H72.7918V110.412H77.7299V105.473Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3184 105.473H82.3803V110.412H87.3184V105.473Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 105.473H87.1746V110.412H92.1126V105.473Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M101.701 105.473H96.7631V110.412H101.701V105.473Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 105.473H101.557V110.412H106.495V105.473Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 105.473H115.94V110.412H120.878V105.473Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 110.268H58.4091V115.206H63.3472V110.268Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1414 110.268H63.2033V115.206H68.1414V110.268Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 110.268H67.9976V115.206H72.9356V110.268Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 110.268H72.7918V115.206H77.7299V110.268Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 110.268H77.5861V115.206H82.5241V110.268Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 110.268H87.1746V115.206H92.1126V110.268Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M111.29 110.268H106.352V115.206H111.29V110.268Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 110.268H115.94V115.206H120.878V110.268Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1702 115.062H39.2321V120H44.1702V115.062Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7587 115.062H48.8206V120H53.7587V115.062Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9356 115.062H67.9976V120H72.9356V115.062Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7299 115.062H72.7918V120H77.7299V115.062Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5241 115.062H77.5861V120H82.5241V115.062Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1126 115.062H87.1746V120H92.1126V115.062Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 115.062H111.146V120H116.084V115.062Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M120.878 115.062H115.94V120H120.878V115.062Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0.878113 0V33.5597H34.4378V0H0.878113ZM29.6436 28.7655H5.67236V4.79425H29.6436V28.7655Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1746 0V33.5597H120.734V0H87.1746ZM115.94 28.7655H91.9688V4.79425H115.94V28.7655Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0.878113 86.2964V119.856H34.4378V86.2964H0.878113ZM29.6436 115.062H5.67236V91.0907H29.6436V115.062Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M111.146 9.58849H96.7631V23.9712H111.146V9.58849Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreQr);
export default __webpack_public_path__ + "static/media/appstore-qr.c3d94276546fbbf9afc352ef58e6a61a.svg";
export { ForwardRef as ReactComponent };